export const urlknowledgeList = '/api/XOrg/BookMaterial/knowledgeList';
export const urladdKnowledge = '/api/XOrg/BookMaterial/addKnowledge';
export const urlreviseKnowledge = '/api/XOrg/BookMaterial/reviseKnowledge';
export const urlDeleteKnowledge = '/api/XOrg/BookMaterial/deleteKnowledge';

import http from 'lib/http';

export interface IKnowledgeList {
  code: string;
  knowledgeList: {
    /* Name */
    Id: string;
    KnowledgeName: string;
    questionCount: string;
  }[];
  totalCount:number;
  notsetCount:number;
}

export interface Imsg {
  coode: string;
  msg: string;
}

// 获取题库知识点列表
export function GetKnowledgeList(courseId: string,IsTest?:boolean) {
  return http.post<IKnowledgeList>(urlknowledgeList, {
    courseId,IsTest
  });
}

// 添加题库知识点
export function AddKnowledge(courseId: string, knowledgeName: string) {
  return http.post<Imsg>(urladdKnowledge, {
    courseId, knowledgeName
  });
}

//  添加题库知识点名称
export function ReviseKnowledge(knowledgeId: string, knowledgeName: string) {
  return http.post<Imsg>(urlreviseKnowledge, {
    knowledgeId, knowledgeName
  });
}
//  删除题库知识点
export function DeleteKnowledge(knowledgeId: string, courseId: string) {
  return http.post<Imsg>(urlDeleteKnowledge, {
    knowledgeId, courseId
  });
}
